import * as React from 'react'

import { Icon } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import Loading from 'modules/core/components/Loading'
import Modal from 'modules/core/components/Modal'
import { useAsyncData } from 'modules/core/hooks/useAsyncData'
import helpCenterUrl from 'modules/core/lib/helpCenterUrl'
import i18n from 'modules/core/lib/i18n'

import documents from 'modules/documents/store/collections/documents'
import useFetchLeave from 'modules/timeoff/hooks/useFetchLeave'
import LeaveForm from 'modules/timeoff/lib/LeaveForm'
import { useContractsVersion } from 'modules/timeoff/lib/contractsVersionContext'

import Content from './Content'
import styles from './index.module.css'

interface Props {
  leaveId: number
  onClose: () => void
}

const EditMedicalLeavePage = ({ leaveId, onClose }: Props) => {
  const { leaveLoading, leave } = useFetchLeave({
    leaveId,
    onClose,
  })
  const { startsOn } = useContractsVersion()

  const form = React.useMemo(() => new LeaveForm(leave.toJS()), [leave])

  const type = i18n.t('time_off.medical_leave.updates.types.medical_leave_start')

  const title = i18n.t('time_off.medical_leave.updates.title_modal')

  const description = i18n.t('time_off.medical_leave.updates.new_modal.description', {
    type,
  })
  useAsyncData(
    () =>
      documents.fetch({
        data: {
          leave_id: leave.attributes.id,
        },
      }),
    []
  )

  const isLoading = leaveLoading

  return (
    <Modal illustration="user-tie" title={title} description={description} onClose={onClose}>
      {isLoading && <Loading />}
      {!isLoading && (
        <>
          <Content readOnly form={form} leave={leave} contractStartsOn={startsOn} />
          <div className={styles.notice}>
            {i18n.t('time_off.medical_leave.not_editable_notice.description')}
            <a
              className={styles.supportLink}
              href={helpCenterUrl('new_request')}
              target="_blank"
              rel="noopener noreferrer"
            >
              {i18n.t('time_off.medical_leave.not_editable_notice.link')}
              <div className={styles.icon}>
                <Icon.Medium icon="arrow-right" color="viridian1200" />
              </div>
            </a>
          </div>
        </>
      )}
    </Modal>
  )
}

export default observer(EditMedicalLeavePage)
